<div class="card">
    <div class="cardTitle">
        <h2>{{ 'dashboard.scheduledChannelSnapshots.title' | translate }}</h2>
    </div>

    <div class="cardContent">
        <form [formGroup]="form">
            @if (isShijiUser()) {
                <div class="inputGroup">
                    <label for="supplierId">{{ 'generalKeywords.supplier' | translate }}</label>
                    <div class="inputWrapper">
                        <app-form-error
                            [parentForm]="$any(form)"
                            [controlPath]="'supplierId'"
                            [controlLabel]="'generalKeywords.supplier'"
                        />
                        <app-typeahead-select
                            type="text"
                            formControlName="supplierId"
                            [optionsList]="suppliers"
                            [idKey]="'id'"
                            [labelKey]="'companyName'"
                            (change)="onSupplierChange()"
                        />
                    </div>
                </div>
            }

            <div class="inputGroup">
                <label for="enabled">{{ 'dashboard.scheduledChannelSnapshots.enabled.label' | translate }}</label>
                <div class="checkboxWrapper">
                    <input type="checkbox" class="toggle" id="enabled" formControlName="enabled" />
                    <label class="checkboxLabel" for="enabled"></label>
                </div>
            </div>

            <div class="inputGroup">
                <label for="distributionChannels">{{ 'dashboard.scheduledChannelSnapshots.channels.label' | translate }}</label>
                <div class="inputWrapper">
                    <app-form-error
                        [parentForm]="$any(form)"
                        [controlPath]="'distributionChannels'"
                        [controlLabel]="'dashboard.scheduledChannelSnapshots.channels.label'"
                    />
                    <app-multi-select-input
                        id="distributionChannels"
                        formControlName="distributionChannels"
                        [optionsList]="distributionChannels"
                        [idKey]="'value'"
                        [labelKey]="'label'"
                    />
                </div>
            </div>

            <div class="inputGroup noBorder">
                <label>{{ 'dashboard.scheduledChannelSnapshots.selectionMode.label' | translate }}</label>
                <div class="inputWrapper">
                    <app-option-switch
                        [firstOption]="{
                            label: 'dashboard.scheduledChannelSnapshots.selectionMode.includeListings',
                            value: ScheduledChannelSnapshotListingSelectionMode.INCLUDE,
                        }"
                        [secondOption]="{
                            label: 'dashboard.scheduledChannelSnapshots.selectionMode.excludeListings',
                            value: ScheduledChannelSnapshotListingSelectionMode.EXCLUDE,
                        }"
                        [initialValue]="listingsSelectionMode()"
                        (valueChanged)="onListingsSelectionModeChange($event)"
                    />
                </div>
            </div>

            <div class="inputGroup listing-selector-wrapper">
                <label></label>
                <div class="inputWrapper">
                    <app-typeahead-select
                        [optionsList]="listingOptions()"
                        [idKey]="'id'"
                        [labelKey]="'name'"
                        formControlName="tempListing"
                        [placeholder]="listingsPlaceholder()"
                        (change)="onSelectSelectedListings($event)"
                    />
                </div>
            </div>

            <div class="selectedListingsWrapper">
                @if (selectedListingsIdsValue().length) {
                    <div class="selectedListingsList" [formGroup]="form">
                        <app-data-grid [data]="selectedListings()" [columns]="importItemColumns" />
                    </div>
                }
            </div>

            <div
                class="inputGroup"
                [class.noBorder]="
                    frequencyValue() == ScheduledChannelSnapshotFrequency.WEEKLY ||
                    frequencyValue() == ScheduledChannelSnapshotFrequency.MONTHLY
                "
                formGroupName="schedule"
            >
                <label>{{ 'dashboard.scheduledChannelSnapshots.frequency.label' | translate }}</label>
                <div class="row frequencyAndTimeWrapper">
                    <div class="col-md">
                        <div class="inputWrapper twoRows">
                            <label for="frequency">{{ 'dashboard.scheduledChannelSnapshots.interval.label' | translate }}</label>
                            <select type="text" id="frequency" formControlName="frequency" (change)="onFrequencyChange()">
                                <option [value]="ScheduledChannelSnapshotFrequency.DAILY">
                                    {{
                                        scheduledChannelSnapshotFrequencyTranslationMap[ScheduledChannelSnapshotFrequency.DAILY] | translate
                                    }}
                                </option>
                                <option [value]="ScheduledChannelSnapshotFrequency.WEEKLY">
                                    {{
                                        scheduledChannelSnapshotFrequencyTranslationMap[ScheduledChannelSnapshotFrequency.WEEKLY]
                                            | translate
                                    }}
                                </option>
                                <option [value]="ScheduledChannelSnapshotFrequency.MONTHLY">
                                    {{
                                        scheduledChannelSnapshotFrequencyTranslationMap[ScheduledChannelSnapshotFrequency.MONTHLY]
                                            | translate
                                    }}
                                </option>
                                <option [value]="ScheduledChannelSnapshotFrequency.MANUAL">
                                    {{
                                        scheduledChannelSnapshotFrequencyTranslationMap[ScheduledChannelSnapshotFrequency.MANUAL]
                                            | translate
                                    }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md startTime">
                        <label for="time">{{ 'dashboard.scheduledChannelSnapshots.startTime.label' | translate }}</label>
                        <div class="inputWrapper">
                            <app-form-error
                                [parentForm]="$any(form)"
                                [controlPath]="'schedule.time'"
                                [controlLabel]="'dashboard.scheduledChannelSnapshots.startTime.label'"
                            />
                            <input type="time" id="time" formControlName="time" appBlurOnEnter />
                            <label for="time" class="suffix">{{
                                'dashboard.scheduledChannelSnapshots.startTime.UTCTime' | translate
                            }}</label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="inputGroup" [formGroup]="$any(form.get('schedule.daysOfWeek'))" *ifNotDisabled="'schedule.daysOfWeek'">
                <div class="label">{{ 'dashboard.scheduledChannelSnapshots.days.label' | translate }}</div>
                <div class="inputWrapper">
                    <app-form-error
                        [parentForm]="$any(form)"
                        [controlPath]="'schedule.daysOfWeek'"
                        [controlLabel]="'dashboard.scheduledChannelSnapshots.days.label'"
                    />
                    <div class="days">
                        <span>
                            <input type="checkbox" id="monday" formControlName="monday" />
                            <label class="noLabelStyles" for="monday">{{
                                'dashboard.scheduledChannelSnapshots.days.mon' | translate
                            }}</label>
                        </span>

                        <span>
                            <input type="checkbox" id="tuesday" formControlName="tuesday" />
                            <label class="noLabelStyles" for="tuesday">{{
                                'dashboard.scheduledChannelSnapshots.days.tue' | translate
                            }}</label>
                        </span>

                        <span>
                            <input type="checkbox" id="wednesday" formControlName="wednesday" />
                            <label class="noLabelStyles" for="wednesday">{{
                                'dashboard.scheduledChannelSnapshots.days.wed' | translate
                            }}</label>
                        </span>

                        <span>
                            <input type="checkbox" id="thursday" formControlName="thursday" />
                            <label class="noLabelStyles" for="thursday">{{
                                'dashboard.scheduledChannelSnapshots.days.thu' | translate
                            }}</label>
                        </span>

                        <span>
                            <input type="checkbox" id="friday" formControlName="friday" />
                            <label class="noLabelStyles" for="friday">{{
                                'dashboard.scheduledChannelSnapshots.days.fri' | translate
                            }}</label>
                        </span>

                        <span>
                            <input type="checkbox" id="saturday" formControlName="saturday" />
                            <label class="noLabelStyles" for="saturday">{{
                                'dashboard.scheduledChannelSnapshots.days.sat' | translate
                            }}</label>
                        </span>

                        <span>
                            <input type="checkbox" id="sunday" formControlName="sunday" />
                            <label class="noLabelStyles" for="sunday">{{
                                'dashboard.scheduledChannelSnapshots.days.sun' | translate
                            }}</label>
                        </span>
                    </div>
                </div>
            </div>

            <div class="inputGroup" formGroupName="schedule" *ifNotDisabled="'schedule.dayOfMonth'">
                <label for="dayOfMonth">{{ 'dashboard.scheduledChannelSnapshots.dayOfMonth' | translate }}</label>
                <div class="inputWrapper">
                    <app-form-error
                        [parentForm]="$any(form)"
                        [controlPath]="'dayOfMonth'"
                        [controlLabel]="'dashboard.scheduledChannelSnapshots.dayOfMonth'"
                    />
                    <input type="number" id="dayOfMonth" formControlName="dayOfMonth" appBlurOnEnter />
                </div>
            </div>

            @let entityTracking = currentSnapshotEntityTracking()?.entityTracking;
            @if (entityTracking) {
                <div class="inputGroup">
                    <label>{{ 'generalKeywords.auditData' | translate }}</label>
                    <div class="inputWrapper">
                        <div>
                            {{
                                'dashboard.scheduledChannelSnapshots.audit.createdby'
                                    | translate
                                        : {
                                              createdBy: entityTracking.createdBy,
                                              createdAt: entityTracking.createdAt | date: 'MMMM d, yyyy HH:mm',
                                          }
                            }}
                            @if (entityTracking.modifiedAt) {
                                |
                                {{
                                    'dashboard.scheduledChannelSnapshots.audit.modifiedby'
                                        | translate
                                            : {
                                                  modifiedBy: entityTracking.modifiedBy,
                                                  modifiedAt: entityTracking.modifiedAt | date: 'MMMM d, yyyy HH:mm',
                                              }
                                }}
                            }
                        </div>
                    </div>
                </div>
            }
        </form>
    </div>
    <div class="cardFooter">
        <button type="submit" class="button primary" (click)="saveScheduledChannelSnapshot()">
            {{ 'generalKeywords.confirm' | translate }}
        </button>
        <button type="button" class="button" (click)="closeModal()">
            {{ 'generalKeywords.cancel' | translate }}
        </button>
    </div>
</div>
